import { render, staticRenderFns } from "./Cavs.vue?vue&type=template&id=d684f9b2&scoped=true"
import script from "./Cavs.vue?vue&type=script&lang=js"
export * from "./Cavs.vue?vue&type=script&lang=js"
import style0 from "./Cavs.vue?vue&type=style&index=0&id=d684f9b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d684f9b2",
  null
  
)

export default component.exports